const ApiPath = {
  Login: "ms-profile/user/login",
  Logout: "ms-profile/user/logout",
  Refresh: "ms-profile/user/refresh",
  GetUser: "ms-profile/user",
  GetUsers: "ms-profile/user/users",
  Station: "ms-pos/station",
  DailyRecords: "ms-pos/daily-record",
  Transaction: "ms-pos/transaction",
  Promo: "ms-pos-promo/promo",
  Product: "ms-stock/product",
  Category: "ms-stock/category",
  Stock: "ms-stock/stock",
  StationUsers: "ms-pos/user/user-station",
  Storage: "ms-storage/upload",
  OrderSummary: "ms-stock/order",
  ShiftRecords: "ms-pos/shift",
  GenerateReport: "ms-pos/report",
  ReportList: "ms-report/report",
  UpdateReport: (id) => `ms-report/report/${id}`,
};

export default ApiPath;
